import { render, staticRenderFns } from "./LiveStatsDemo.vue?vue&type=template&id=6e76d90c"
import script from "./LiveStatsDemo.vue?vue&type=script&lang=js"
export * from "./LiveStatsDemo.vue?vue&type=script&lang=js"
import style0 from "./LiveStatsDemo.vue?vue&type=style&index=0&id=6e76d90c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports